import { useCallback } from 'react';

export interface MouseDownHandlerProps {
  drag: React.MutableRefObject<boolean>;
  blockRef: React.MutableRefObject<HTMLDivElement | null>;
  startX: React.MutableRefObject<number>;
  scrollLeft: React.MutableRefObject<number>;
}

export const useMouseDownHandler = ({ drag, blockRef, startX, scrollLeft }: MouseDownHandlerProps) =>
  useCallback((e: MouseEvent) => {
    drag.current = true;
    startX.current = e.pageX - blockRef.current!.offsetLeft;
    scrollLeft.current = blockRef.current!.scrollLeft;
  }, []);
